/* esm.sh - applesauce-core@5.2.0/dist/helpers/pipeline */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/pipeline.mjs";
